import script from "./ReportsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import DescriptionHeader from "@/components/neue/DescriptionHeader.vue";
script.components = Object.assign({}, { DescriptionHeader }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DescriptionHeader }, script.__o.components);}